export const SIDEBAR_ID = 'app-sidebar'
